import React from 'react';

import styles from 'components/atoms/IconButton/IconButton.module.scss';

export const IconButton = ({ icon, style, onClick }) => (
  <button onClick={onClick} style={style} className={styles.iconButton}>
    {icon}
  </button>
);
